/**
 * Debug Time Utility
 * Reads an optional offset (in days) from localStorage key "gemba_debug_time_offset"
 * and returns a Date shifted by that many days.
 * When offset is 0 (or key is absent), returns the real current time.
 */

const DEBUG_OFFSET_KEY = 'gemba_debug_time_offset';

export function getCurrentDate(): Date {
  const now = new Date();
  if (typeof window === 'undefined') return now;
  try {
    const raw = localStorage.getItem(DEBUG_OFFSET_KEY);
    const offset = raw ? parseInt(raw, 10) : 0;
    if (offset && !isNaN(offset) && offset > 0) {
      now.setDate(now.getDate() + offset);
    }
  } catch {
    // ignore localStorage errors (SSR / private mode)
  }
  return now;
}

export function getDebugOffset(): number {
  if (typeof window === 'undefined') return 0;
  try {
    const raw = localStorage.getItem(DEBUG_OFFSET_KEY);
    const offset = raw ? parseInt(raw, 10) : 0;
    return isNaN(offset) ? 0 : offset;
  } catch {
    return 0;
  }
}

export function setDebugOffset(days: number): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(DEBUG_OFFSET_KEY, String(days));
  } catch {
    // ignore
  }
}
